__turbopack_context__.v({
  "anchor": "tweet-media-video-module__74LCAq__anchor",
  "videoButton": "tweet-media-video-module__74LCAq__videoButton",
  "videoButtonIcon": "tweet-media-video-module__74LCAq__videoButtonIcon",
  "viewReplies": "tweet-media-video-module__74LCAq__viewReplies",
  "watchOnTwitter": "tweet-media-video-module__74LCAq__watchOnTwitter",
});
